var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99337 1.33334C4.31337 1.33334 1.33337 4.32001 1.33337 8.00001C1.33337 11.68 4.31337 14.6667 7.99337 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 7.99337 1.33334ZM8.00004 13.3333C5.05337 13.3333 2.66671 10.9467 2.66671 8.00001C2.66671 5.05334 5.05337 2.66668 8.00004 2.66668C10.9467 2.66668 13.3334 5.05334 13.3334 8.00001C13.3334 10.9467 10.9467 13.3333 8.00004 13.3333Z",
    fill: "#A8ADB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 4.66666H7.33337V8.66666L10.8334 10.7667L11.3334 9.94666L8.33337 8.16666V4.66666Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.75ef769866b8d7b6f9131eff68200ad7.svg";
export { ForwardRef as ReactComponent };